import usePrivateAxios from "@/common/api/usePrivateAxios";
import { HolidayData, HolidayResponse } from "@/common/types/holidays";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

const useHoliday: (id: string) => UseQueryResult<HolidayData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<HolidayResponse, unknown, HolidayData>({
    queryKey: ['holiday', id],
    queryFn: () => privateAxios.get(`/calendar/holidays/${id}`),
    select: (data) => data?.data?.data
  });
};

export default useHoliday;
